import { CompaniesTable } from 'components/Tables/CompaniesTable/CompaniesTable'
import { UnmatchedDoorsTable } from './UnmatchedDoorsTable'
import { StandardSummaryResponse } from 'models/paginated-response'
import { FilterIdentifier } from 'models/saved_view'
import { Category, SubCategory } from 'models/companies'
import { useOpportunitiesContext } from 'pages/app/opportunities/opportunities-context'

type UnmatchedChainDoorTableProps = {
  pageParamName: string
  setTotalRowsCount?: (count: StandardSummaryResponse) => void
  tableKey?: string
  category: Category
  subCategory: SubCategory
}

export function UnmatchedChainDoorTable(props: UnmatchedChainDoorTableProps) {
  const { selectedTag } = useOpportunitiesContext()

  const { pageParamName, setTotalRowsCount, tableKey, category, subCategory } =
    props

  const UNMATCHED_CHAINS_TABLE_KEY = tableKey
    ? `${tableKey}_CHAINS`
    : 'UNMATCHED_CHAINS_TABLE'
  const UNMATCHED_DOORS_TABLE_KEY = tableKey
    ? `${tableKey}_DOORS`
    : 'UNMATCHED_DOORS_TABLE'
  const filterIdentifier = subCategory.id.toString() as FilterIdentifier
  const baseFilters = { unmatched: true }

  return (
    <>
      {selectedTag === 'custom-companies' ? (
        <CompaniesTable
          tableKey={UNMATCHED_CHAINS_TABLE_KEY}
          pageParamName={`${pageParamName}-chain-page`}
          category={category}
          subCategory={subCategory}
          setTotalRowsCount={setTotalRowsCount}
          baseFilters={baseFilters}
          defaultColumnVisibility={{}}
        />
      ) : null}

      {selectedTag === 'custom-locations' ? (
        <UnmatchedDoorsTable
          tableKey={UNMATCHED_DOORS_TABLE_KEY}
          pageParamName={`${pageParamName}-door-page`}
          filterIdentifierModifier={filterIdentifier}
          setTotalRowsCount={setTotalRowsCount}
          useAllDoorProxies={true}
          defaultColumnVisibility={{}}
          subCategory={subCategory}
        />
      ) : null}
    </>
  )
}
